import React from 'react';

const ModalCloseButton = ({ onClick, className = '' }) => {
  return (
    <button className={`close ${className}`} data-dismiss="modal" aria-label="Close" onClick={onClick}>
      <span aria-hidden="true">&times;</span>
    </button>
  );
};

export default ModalCloseButton;